import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF7EE]">
      <p className="font-heading text-3xl text-[#3D5844] animate-pulse">Turning the page…</p>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (user.role !== "admin" && user.status !== "approved") return <Navigate to="/pending" replace />;
  return children;
}
